import { SearchHistoryContainer } from "./job-boards-search-history-infinite-scroll";
var JobBoardsSearchHistoryController = /** @class */ (function () {
    /*@ngInject*/
    function JobBoardsSearchHistoryController($rootScope, jobService, resumeService, alertsAndNotificationsService) {
        this.$rootScope = $rootScope;
        this.jobService = jobService;
        this.resumeService = resumeService;
        this.alertsAndNotificationsService = alertsAndNotificationsService;
    }
    JobBoardsSearchHistoryController.prototype.$onInit = function () {
        var _this = this;
        //variables
        this.searchHistory = [];
        this.jobBoards = [];
        this.searchHistoryContainer = null;
        //flags
        this.isPanelOpen = [];
        this.isPanelOpen.push(true);
        this.getAllJobBoards(function () {
            _this.searchHistoryContainer = new SearchHistoryContainer(_this.jobId, _this.jobBoards, _this.jobService, _this.alertsAndNotificationsService);
            _this.searchHistoryContainer.searchHistoryQueryFilter = {
                pageNum: 1,
                size: 5
            };
        });
    };
    JobBoardsSearchHistoryController.prototype.getAllJobBoards = function (successCallback) {
        var _this = this;
        this.resumeService.getAllSourceTypes(function (data) {
            if (data.length > 0) {
                _this.jobBoards = data;
                if (successCallback) {
                    successCallback();
                }
            }
        }, function (error) {
            if (_this.$rootScope.isOnline) {
                _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    };
    JobBoardsSearchHistoryController.prototype.getJobBoardsSearchHistory = function () {
        var _this = this;
        this.jobService.getJobBoardsSearchHistory(this.jobId, function (data) {
            _this.searchHistory = data;
            _this._parseSearch();
        }, function (error) {
            if (_this.$rootScope.isOnline) {
                _this.alertsAndNotificationsService.showBannerMessage(error, 'danger');
            }
        });
    };
    JobBoardsSearchHistoryController.prototype._parseSearch = function () {
        var _this = this;
        angular.forEach(this.searchHistory, function (search, key) {
            search.jobBoards = angular.copy(_this._addJobBoardDetails(search.jobBoardId, search.daxtraParameters));
            delete search.jobBoardId;
        });
        console.log('parsed search history');
        console.log(this.searchHistory);
    };
    JobBoardsSearchHistoryController.prototype._addJobBoardDetails = function (jobBoardIds, daxtraParameters) {
        var _this = this;
        var jobBoards = [];
        angular.forEach(jobBoardIds, function (jobBoardId, key) {
            var jobBoard = _this.jobBoards.find(function (jobBoard) {
                return jobBoard.id === jobBoardId;
            });
            //Parse daxtra params
            // jobBoard.allDaxtraParameters = angular.copy(_addDaxtraParametersToJobBoard(daxtraParameters, jobBoard.daxtraCode.toLowerCase()));
            // jobBoard.daxtraParameters = jobBoard.allDaxtraParameters.filter(function (param) {
            //     return param.value !== "";
            // });
            jobBoards.push(jobBoard);
        });
        return jobBoards;
    };
    return JobBoardsSearchHistoryController;
}());
JobBoardsSearchHistoryController.$inject = ['$rootScope', 'jobService', 'resumeService', 'alertsAndNotificationsService'];
// import * as TEMPLATE from './job-boards-search-history.html';
import * as TEMPLATE from 'raw-loader!./job-boards-search-history.html';
export var JobBoardsSearchHistoryComponent = {
    selector: 'jobBoardsSearchHistory',
    component: {
        bindings: {
            jobId: '@',
            jobTitle: '@',
            clientOrBuName: '@'
        },
        controller: JobBoardsSearchHistoryController,
        template: TEMPLATE.default
        // templateUrl: 'app/partials/missioncontrol/candidateJobMatchesWorkflow/candidateJobMatchesWorkflow/addCandidatesFromJobBoards/jobBoardsSupportedParameters/jobBoardsSearchHistory/job-boards-search-history.html'
    }
};
//# sourceMappingURL=job-boards-search-history.component.js.map